import { useState, useEffect, useRef } from 'react';
import { applyStyles } from '../../utils/styleUtils';

const FloatingTimerElement = ({ element }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [isSticky, setIsSticky] = useState(false);
  const timerRef = useRef(null);
  const initialTopRef = useRef(null);
  const style = applyStyles(element);

  useEffect(() => {
    const durationSeconds = element.duration || 600;
    const endTime = Date.now() + (durationSeconds * 1000);

    const formatTime = (seconds) => {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    const updateTimer = () => {
      const now = Date.now();
      const remainingMs = Math.max(0, endTime - now);
      const remainingSeconds = Math.floor(remainingMs / 1000);
      
      const timerText = element.text.replace('{{timer}}', formatTime(remainingSeconds));
      setTimeLeft(timerText);

      if (remainingSeconds > 0) {
        setTimeout(updateTimer, 1000);
      }
    };

    updateTimer();
  }, [element.text, element.duration]);

  useEffect(() => {
    const handleScroll = () => {
      if (timerRef.current) {
        const rect = timerRef.current.getBoundingClientRect();
        
        if (initialTopRef.current === null && !isSticky) {
          initialTopRef.current = rect.top + window.scrollY;
        }

        const shouldBeSticky = window.scrollY > initialTopRef.current && initialTopRef.current !== null;
        setIsSticky(shouldBeSticky);
      }
    };

    setTimeout(() => {
      handleScroll();
      window.addEventListener('scroll', handleScroll, { passive: true });
    }, 100);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isSticky]);

  const timerStyle = {
    ...style,
    backgroundColor: element['background-color'] || 'rgb(241, 139, 95)',
    color: element['color'] || '#ffffff'
  };

  return (
    <div 
      ref={timerRef}
      className={`element-floating-timer ${isSticky ? 'sticky' : ''}`}
      style={timerStyle}
    >
      <div className="floating-timer-text">
        {timeLeft}
      </div>
    </div>
  );
};

export default FloatingTimerElement;

